export function usePreventScroll(): (prevent: boolean) => Promise<void> {
  return async (prevent: boolean) => {
    if (prevent) {
      document.body.style.overflow = "hidden"
    } else {
      document.body.style.overflowY = "auto"
    }
  }
}
